import misc from './misc';

const { getEmailQuery, buildTestEmail } = misc;

export default {
  reengageSyncNetworkConnections1: {
    title: 'Reengagement » How to Sync Your Connections',
    description: '2 days after sign up, to users not synced yet',
    hide: ({ isReferralsFeatureEnabled }) => !isReferralsFeatureEnabled,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.employeeReengageSyncNetworksFirstEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_FIRST_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_FIRST_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_FIRST_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('reengagement/sync-your-connections-1', {
      template_subject: 'template.EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_FIRST_SUBJECT',
      template_bodyOne: 'template.EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_FIRST_BODY_ONE',
      template_plainHTML: 'template.EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_FIRST_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        useGamification
        employeeReengageSyncNetworksFirstEmailPlain
      }

      template_subject: template(where: {
        key: "EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_FIRST_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_FIRST_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyTwo: template(where: {
        key: "EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_FIRST_BODY_TWO",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_FIRST_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
      user: `leaderboard {
        raffleMode
        prizes {
          first {
            title
            image {
              id
              fileLocation
            }
          }
          second {
            title
            image {
              id
              fileLocation
            }
          }
          third {
            title
            image {
              id
              fileLocation
            }
          }
        }
      }`,
    }),
  },
  reengageSyncNetworkConnections2: {
    title: 'Reengagement » Reminder to Sync Your Connections',
    description: '7 days after sign up, to users not synced yet',
    hide: ({ isReferralsFeatureEnabled }) => !isReferralsFeatureEnabled,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.employeeReengageSyncNetworksSecondEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_SECOND_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_SECOND_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_SECOND_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('reengagement/sync-your-connections-2', {
      template_subject: 'template.EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_SECOND_SUBJECT',
      template_bodyOne: 'template.EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_SECOND_BODY_ONE',
      template_plainHTML: 'template.EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_SECOND_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        useGamification
        employeeReengageSyncNetworksSecondEmailPlain
      }

      template_subject: template(where: {
        key: "EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_SECOND_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_SECOND_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_SECOND_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
      user: `leaderboard {
        raffleMode
        prizes {
          first {
            title
            image {
              id
              fileLocation
            }
          }
          second {
            title
            image {
              id
              fileLocation
            }
          }
          third {
            title
            image {
              id
              fileLocation
            }
          }
        }
      }`,
    }),
  },
  reengageSyncNetworkConnections3: {
    title: 'Reengagement » Final Reminder to Sync',
    description: '14 days after sign up, to users not synced yet',
    hide: ({ isReferralsFeatureEnabled }) => !isReferralsFeatureEnabled,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.employeeReengageSyncNetworksThirdEmailPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_THIRD_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_THIRD_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_THIRD_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('reengagement/sync-your-connections-3', {
      template_subject: 'template.EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_THIRD_SUBJECT',
      template_bodyOne: 'template.EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_THIRD_BODY_ONE',
      template_plainHTML: 'template.EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_THIRD_PLAIN_HTML',
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        useGamification
        employeeReengageSyncNetworksThirdEmailPlain
      }

      template_subject: template(where: {
        key: "EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_THIRD_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_THIRD_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyTwo: template(where: {
        key: "EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_THIRD_BODY_TWO",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_EMPLOYEE_REENGAGE_SYNCNETWORKS_THIRD_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
      user: `leaderboard {
        raffleMode
        prizes {
          first {
            title
            image {
              id
              fileLocation
            }
          }
          second {
            title
            image {
              id
              fileLocation
            }
          }
          third {
            title
            image {
              id
              fileLocation
            }
          }
        }
      }`,
    }),
  },
};


// WEBPACK FOOTER //
// ./src/emails/previews/syncNetworkEmails.js